import * as React from 'react'

import { Modal } from '@material-ui/core'
import Divider from '@material-ui/core/Divider'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'

import './style.scss'

interface IBottomMenuFormsItem {
  title?: string
  content?: string
  image?: string
}

interface IBottomMenutReportsItem {
  title?: string
  content?: string
  image?: string
}

interface IBottomMenutReportItem {
  title?: string
  content?: string
  image?: string
}

interface IBottomFormTabItems {
  title?: string
  content?: string
  image?: string
}

interface IProps
  extends IBottomMenuFormsItem,
    IBottomMenutReportsItem,
    IBottomMenutReportItem,
    IBottomFormTabItems {
  open: boolean
  report?: boolean
  form?: boolean
  onClose: any
  distributeForm?: any
  downloadReport?: any
  viewAnswers?: any
  editForm?: any
  previewForm?: any
  copyReport?: any
  sendReminder?: any
  editReport?: any
  share?: boolean
  shareViaEmail?: any
}

export class DrawerModal extends React.PureComponent<IProps> {
  bottomFormsItems: IBottomMenuFormsItem[] = [
    {
      title: 'View Answers',
      content: 'Review form answers from parents and key people',
      image: require('../../assets/img/view.svg')
    },
    {
      title: 'Distribute form',
      content: 'Select which user you want to send the form to complete',
      image: require('../../assets/img/airplane.svg')
    },
    {
      title: 'Send reminder',
      content:
        'We can send a reminder to any key personel to complete a desired orm',
      image: require('../../assets/img/timer.svg')
    }
  ]

  bottomReportsItems: IBottomMenutReportsItem[] = [
    {
      title: 'Edit Report'
    },
    {
      title: 'Copy Report'
    }
  ]

  bottomReportItems: IBottomMenutReportsItem[] = [
    {
      title: 'Download'
    },
    {
      title: 'Share via email'
    }
  ]

  bottomFormTabItems: IBottomFormTabItems[] = [
    {
      title: 'Preview'
    },
    {
      title: 'Edit Form'
    }
  ]

  addFunctions = index => {
    const {
      sendReminder,
      distributeForm,
      viewAnswers,
      report,
      copyReport,
      editReport,
      share,
      downloadReport,
      shareViaEmail,
      previewForm,
      editForm,
      form
    } = this.props
    if (report) {
      return index === 0 ? editReport() : copyReport()
    }
    if (share) {
      return index === 0 ? downloadReport() : shareViaEmail()
    }
    if (form) {
      return index === 0 ? previewForm() : editForm()
    } else {
      return index === 0
        ? viewAnswers()
        : index === 1
        ? distributeForm()
        : sendReminder()
    }
  }

  listItem = (
    index: number,
    item: IBottomMenuFormsItem | IBottomMenutReportsItem
  ) => {
    const { report, share } = this.props

    return (
      <React.Fragment key={index}>
        <ListItem
          button={true}
          className="bottom-list-item"
          onClick={() => this.addFunctions(index)}
          style={{
            paddingBottom: 30,
            paddingTop: 30,
            borderRadius: 5,
            display: 'flex',
            alignItems: 'flex-start'
          }}
        >
          {report || share ? (
            <div className="content-wrapper">
              <div className="content-title">{item.title}</div>
            </div>
          ) : (
            <React.Fragment>
              <img className="item-image" src={item.image} />
              <div className="content-wrapper">
                <div className="content-title">{item.title}</div>
                <div className="content">{item.content}</div>
              </div>
            </React.Fragment>
          )}
        </ListItem>
        {index === 2 && !report ? null : <Divider />}
      </React.Fragment>
    )
  }

  render() {
    const { open, onClose, report, share, form } = this.props

    return (
      <Modal
        aria-labelledby="choose-type"
        aria-describedby="choose-type-description"
        keepMounted={true}
        className="drawer"
        open={open}
        onClose={() => onClose()}
        onBackdropClick={() => {
          onClose()
        }}
      >
        <div
          className={`modal-wrap ${
            open && !report && !share && !form
              ? 'opened'
              : open && (report || share || form)
              ? 'opened-report'
              : ''
          }`}
          // onClick={onClose(false)}
          style={{
            height: report || form ? 168 : 380
          }}
        >
          <div className="menu-top" />
          <List>
            {report
              ? this.bottomReportsItems.map((item, index) =>
                  this.listItem(index, item)
                )
              : share
              ? this.bottomReportItems.map((item, index) =>
                  this.listItem(index, item)
                )
              : form
              ? this.bottomFormTabItems.map((item, index) =>
                  this.listItem(index, item)
                )
              : this.bottomFormsItems.map((item, index) =>
                  this.listItem(index, item)
                )}
          </List>
        </div>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/BottomModal/index.tsx